export default "__VITE_ASSET__BrAxqZP3__"